
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 156.8 160","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M156.8 81.8c0-6.6-.5-11.4-1.7-16.4H80v29.7h44.1c-.9 7.4-5.7 18.5-16.4 26l-.1 1 23.7 18.4 1.6.2c15.2-14 23.9-34.6 23.9-58.9","fill":"#4285f4"}}),_c('path',{attrs:{"d":"M80 160c21.6 0 39.7-7.1 53-19.4L107.8 121c-6.8 4.7-15.8 8-27.7 8-21.2 0-39.1-14-45.5-33.2l-.9.1L8.9 115l-.3.9C21.7 142 48.7 160 80 160","fill":"#34a853"}}),_c('path',{attrs:{"d":"M34.5 95.8c-1.7-5-2.7-10.3-2.7-15.8s1-10.8 2.6-15.8v-1.1l-25-19.4-.8.4C3.1 54.9 0 67.1 0 80s3.1 25.1 8.5 35.9l26-20.1","fill":"#fbbc05"}}),_c('path',{attrs:{"d":"M80 30.9c15 0 25.2 6.5 30.9 11.9l22.6-22C119.6 7.9 101.6 0 80 0 48.7 0 21.7 18 8.5 44.1l25.9 20.1C40.9 44.9 58.8 30.9 80 30.9","fill":"#eb4335"}})])
          )
        }
      }
    